import React from 'react';
import { get, isEmpty } from 'lodash';
import { generateRomanNumeralsObject } from './function.js';

class ListItemKetQuaTongHopKetQuaThanhTra extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  renderData({ data, totalCol }) {
    const rootStyle = { color: '#0077EE', fontWeight: 'bold' };

    return data.map((item, i) => (
      <span style={{ display: 'contents' }}>
        <tr key={i}>
          <td style={item.rootLevel ? rootStyle : {}}>
            {item.rootLevel ? generateRomanNumeralsObject(100)[i + 1] : null}
          </td>
          <td
            style={item.rootLevel ? rootStyle : { fontWeight: 'bold' }}
            colSpan={
              isEmpty(item.children) && item.rootLevel ? totalCol - 1 : 1
            }
          >
            {item.model.name}
          </td>
          {item.statistics.map((sta, idx) => (
            <td key={idx}>{sta}</td>
          ))}
        </tr>
        {item.children.map((child, idx) => (
          <tr key={idx}>
            <td>{idx + 1}</td>
            <td>{child.model.name}</td>
            {child.statistics.map((sta, j) => (
              <td key={j}>{sta}</td>
            ))}
          </tr>
        ))}
      </span>
    ));
  }

  render() {
    console.log(this.props.dataList);

    return (
      <span style={{ display: 'contents' }}>
        {this.renderData({
          data: get(this.props, 'dataList', []),
          totalCol: this.props.totalCol,
        })}
      </span>
    );
  }
}

export default ListItemKetQuaTongHopKetQuaThanhTra;



// WEBPACK FOOTER //
// ./src/components/modules/thong-ke-bao-cao/datatable/ListItemKetQuaTongHopKetQuaThanhTra.jsx